import React, { useState, useEffect } from 'react';
import { Card, Divider, Modal, IconButton, useMediaQuery, useTheme, CardContent, Grid, Typography, CardMedia, List, ListItem, ListItemText, Box, Checkbox, FormControlLabel, Link  } from '@mui/material';
import {
  Close as CloseIcon,
} from "@mui/icons-material";
import MobilePopupCarousel from "./MobilePopupCarousel";

// After the popup has been seen once, keep it hidden for this long.
const POPUP_HIDE_DURATION_MS = 60 * 60 * 1000; // 1 hour
const POPUP_LAST_SHOWN_KEY = 'popupBannerLastShown';

export const shouldShowPopupBanner = () => {
  try {
    if (sessionStorage.getItem('hidePopup') === 'true') return false;
    const lastShown = Number(localStorage.getItem(POPUP_LAST_SHOWN_KEY));
    return !lastShown || Date.now() - lastShown >= POPUP_HIDE_DURATION_MS;
  } catch {
    return true;
  }
};

const PopupBanner = ({data}) => {
  const [popupBannerData, setPopupBannerData] = useState([]); 
  const theme = useTheme();
  const [selectedItem, setSelectedItem] = useState(null); 
  const [dontShowAgain, setDontShowAgain] = useState(false); 
  const mobileView = useMediaQuery(theme.breakpoints.down("md"));
  const closePopup = () => setPopupOpen(false);
  const openPopup = () => setPopupOpen(true);
  const [popupOpen, setPopupOpen] = useState(true);

  useEffect(() => {
    try {
      localStorage.setItem(POPUP_LAST_SHOWN_KEY, String(Date.now()));
    } catch {}
  }, []);

  useEffect(() => {
    if (data?.result) { 
      setPopupBannerData(data.result);
      if (data.result.length > 0) {
        setSelectedItem({ ...data.result[0], index: 0 });
      }
    }
  }, [data]);

  const handleListItemClick = (item, index) => {
    setSelectedItem({ ...item, index });
  };

  const hasMeaningfulContent = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent.trim().length > 0;
  };

  return (
    <Modal open={popupOpen} onClose={closePopup}>
      <Box
          sx={{
            position: "absolute",
            top: mobileView ? "50%" : "50%",
            left: "50%",
            width: mobileView ? 300 : "60%",
            transform: "translate(-50%, -50%)",
            outline: "none",
          }}
          textAlign="right"
      >
        <div sx={{ position: "absolute", top: 0, right: 0, zIndex: 2 }}>
          <IconButton aria-label="close" onClick={closePopup}>
            <CloseIcon />
          </IconButton>
        </div>
        {!mobileView ? (
      <Box>
        <Card sx={{ display: 'flex', height: '100%', aspectRatio: '18/9', overflow: 'hidden'}}>
        {selectedItem && (
         <>
          <Grid container>
            {/* Left Side: List of Titles */}
            <Grid item xs={12} md={3.5} sx ={{borderRight: `1px solid #707070`, height: "100%", overflowY: 'auto'}} >
              <List component="nav" sx={{ height: '100%', overflowY: 'auto' }}>
                {data?.result?.map((item, index) => (
                  <>
                  <ListItem
                    button
                    key={index}
                    selected={selectedItem?.index === index}
                    onClick={() => handleListItemClick(item, index)}
                    sx={{
                      color: process.env.REACT_APP_COLOR_TEXT || 'white',
                      '&.Mui-selected': {
                        backgroundColor: theme.palette.secondary.accent, 
                        '&:hover': {
                          backgroundColor: theme.palette.secondary.accent, 
                        },
                      },
                      transition: 'background-color 0.3s ease',
                    }}
                  >
                    <ListItemText 
                    primary={item.title} 
                    secondary={item.date} 
                    secondaryTypographyProps={{
                      sx: {
                        color: process.env.REACT_APP_COLOR_TEXT || 'white'
                        },
                      }}/>
                    </ListItem>
                    {index < data.result.length - 1 && <Divider sx={{ bgcolor: "#707070"}} />} 
                    </>
                ))}
              </List>
            </Grid>

            {/* Right Side: Display selected entry */}
            <Grid item xs={12} md={8.5} sx={{ padding: '20px', display: 'flex', flexDirection: 'column', height: '100%', overflowY: 'auto'}}>

              <Typography variant="subtitle1" color={process.env.REACT_APP_COLOR_TEXT || 'white'} align='left' component="div" sx={{wordWrap: 'break-word'  }}>
                  {selectedItem.title}
                </Typography>

                <Link href={selectedItem.link} target="_blank" rel="noopener noreferrer">
                <CardMedia
                  component="img"
                  image={selectedItem.imageUrl}
                  alt={selectedItem.title}
                  sx={{ width: '100%', height: 'auto', objectFit: 'cover', marginBottom: '10px', marginTop: '10px'}}
                />
                </Link>
                {/* <Typography variant="h6" color='white' align='left' component="div" sx={{ marginTop: '10px', wordWrap: 'break-word' }}>
                  {selectedItem.description}
                </Typography> */}
                {selectedItem.content && hasMeaningfulContent(selectedItem.content) && (
                <Typography variant="body1"  color={process.env.REACT_APP_COLOR_TEXT || 'white'} align='left' sx={{ wordWrap: 'break-word'  }}
                dangerouslySetInnerHTML={{ __html: selectedItem.content}}/>
                )}
            </Grid>
          </Grid>
          </>
        )}
        </Card>

      </Box>
       ) : ( 
        <MobilePopupCarousel
        data={data?.result}
        slidesPerView={1}
        spaceBetween={10}
        navigation
        pagination
      />
        )}
      <FormControlLabel
          control={
            <Checkbox
              checked={dontShowAgain}
              onChange={(e) => {
                const checked = e.target.checked;
                setDontShowAgain(checked);
                if (checked) sessionStorage.setItem('hidePopup', 'true');
                else sessionStorage.removeItem('hidePopup');
              }}
            />
          }
          label={<Typography color='white'>Don't show again</Typography>} 
        />
      </Box>
    </Modal>
  );
};

export default PopupBanner;
